/**
 * Okta OIDC configuration for the Release Observatory SPA.
 *
 * Uses Authorization Code + PKCE (no client secret in the browser). All values
 * are read from Vite env vars so nothing tenant-specific is hardcoded.
 */

const env = import.meta.env;

function resolveRedirectUri(): string {
  if (typeof window === 'undefined') return '/callback';
  return `${window.location.origin}/callback`;
}

function resolvePostLogoutRedirectUri(): string {
  if (typeof window === 'undefined') return '/login';
  return `${window.location.origin}/login`;
}

export const OKTA_CONFIG = {
  /** e.g. https://trimble.okta.com/oauth2/default */
  issuer: env.VITE_OKTA_ISSUER ?? '',
  /** Client ID from the Okta Admin Console (SPA app integration). */
  clientId: env.VITE_OKTA_CLIENT_ID ?? '',
  /** Where Okta returns after sign-in. Must be registered in the Okta app. */
  redirectUri: resolveRedirectUri(),
  /** Where Okta returns after sign-out. Must be registered in the Okta app. */
  postLogoutRedirectUri: resolvePostLogoutRedirectUri(),
  /** offline_access enables refresh tokens for silent renewal. */
  scopes: ['openid', 'profile', 'email', 'offline_access'] as string[],
} as const;

/** sessionStorage keys used by the auth flow. */
export const AUTH_KEYS = {
  returnTo: 'okta.return_to',
} as const;
